export const SET_TASK_COMPLETED = 'SET_TASK_COMPLETED';
export const SET_ONBOARDING_COMPLETED = 'SET_ONBOARDING_COMPLETED';

export const setTaskCompleted = (taskName: string) => ({
  type: SET_TASK_COMPLETED,
  payload: taskName,
});

export const setOnboardingCompleted = () => ({
  type: SET_ONBOARDING_COMPLETED,
}); 